import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListItemComponent } from './list-item/list-item.component';
import { NewItemComponent } from './new-item/new-item.component';

const routes: Routes = [{
  path: 'item', component: ListItemComponent
}, { path: 'item/:id', component: NewItemComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ItemRoutingModule { }